import { render, staticRenderFns } from "./InvoiceStubsDialogComponent.vue?vue&type=template&id=5811f0e1&"
import script from "./InvoiceStubsDialogComponent.vue?vue&type=script&lang=js&"
export * from "./InvoiceStubsDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports